import moment from 'moment';
import React from 'react';
import {
	getStartOfPeriod,
	getEndOfPeriod,
	getInitiativeLabelText,
} from './utils';
import { DATE_API_FORMAT, DAYS_IN_WEEK, deviceScale } from '../constants';
import { Container, HandlesWrapper, Label, LeftHandle, RightHandle } from './InitiativeBar.styles';

const MOVE_HANDLE_WIDTH = 6;

class InitiativeBar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			executionStartDate: props.initiative.executionStartDate,
			duration: props.initiative.duration,
			isDrag: false,
			handleMovement: 0,
			movementSide: null,
		}
	}

	getLeftInPixels = () => {
		const { dayWidth, minDate } = this.props;
		const { executionStartDate } = this.state;

		return moment(executionStartDate).diff(moment(minDate), 'days') * dayWidth;
	}

	onLeftMouseMove = (e) => {
		const { dayWidth, minDate, period, setMinDate } = this.props;
		const { duration, executionStartDate, handleMovement } = this.state;
		const { movementX } = e;
		const weekWidth = dayWidth * DAYS_IN_WEEK;

		e.stopPropagation();
		e.preventDefault();

		if (handleMovement > weekWidth) {
			this.setState({
				duration: duration - 1,
				executionStartDate: moment(executionStartDate, moment.ISO_8601).add(1, 'week').format(DATE_API_FORMAT),
				handleMovement: 0,
			});
		} else if (handleMovement < -weekWidth) {
			const newExecutionMomentStartDate = moment(executionStartDate, moment.ISO_8601).subtract(1, 'week');
			this.setState({
				duration: duration + 1,
				executionStartDate: newExecutionMomentStartDate.format(DATE_API_FORMAT),
				handleMovement: 0,
			});
			if (newExecutionMomentStartDate < minDate) {
				setMinDate(getStartOfPeriod(newExecutionMomentStartDate, period));
			}
		} else {
			this.setState({
				handleMovement: handleMovement + movementX / deviceScale,
			});
		}
	};

	onRightMouseMove = (e) => {
		const { dayWidth, maxDate, period, setMaxDate } = this.props;
		const { duration, executionStartDate, handleMovement } = this.state;
		const { movementX } = e;
		const weekWidth = dayWidth * DAYS_IN_WEEK;

		e.stopPropagation();
		e.preventDefault();

		if (handleMovement > weekWidth) {
			this.setState({
				duration: duration + 1,
				handleMovement: 0,
			});
			const initiativeEndDate = moment(executionStartDate).add(duration + 2, 'week')
			if (initiativeEndDate >= maxDate) {
				setMaxDate(getEndOfPeriod(initiativeEndDate, period));
			}
		} else if (handleMovement < -weekWidth) {
			this.setState({
				duration: duration - 1,
				handleMovement: 0,
			});
		} else {
			this.setState({
				handleMovement: handleMovement + movementX / deviceScale,
			});
		}
	};

	onMove = (e) => {
		const { dayWidth, maxDate, minDate, period, setMaxDate, setMinDate } = this.props;
		const { duration, executionStartDate, handleMovement } = this.state;
		const { movementX } = e;
		const weekWidth = dayWidth * DAYS_IN_WEEK;

		e.stopPropagation();
		e.preventDefault();

		if (handleMovement > weekWidth) {
			this.setState({
				executionStartDate: moment(executionStartDate, moment.ISO_8601).add(1, 'week').format(DATE_API_FORMAT),
				handleMovement: 0,
			});
			const initiativeEndDate = moment(executionStartDate).add(duration + 2, 'week')
			if (initiativeEndDate >= maxDate) {
				setMaxDate(getEndOfPeriod(initiativeEndDate, period));
			}
		} else if (handleMovement < -weekWidth) {
			this.setState({
				executionStartDate: moment(executionStartDate, moment.ISO_8601).add(-1, 'week').format(DATE_API_FORMAT),
				handleMovement: 0,
			});
			const newExecutionMomentStartDate = moment(executionStartDate, moment.ISO_8601).subtract(1, 'week');
			if (newExecutionMomentStartDate < minDate) {
				setMinDate(getStartOfPeriod(newExecutionMomentStartDate, period));
			}
		} else {
			this.setState({
				handleMovement: handleMovement + movementX / deviceScale,
			});
		}
	}

	onMouseUp = () => {
		const { initiative, updateInitiativeDuration } = this.props;
		const { duration, executionStartDate } = this.state;

		document.body.removeEventListener('mousemove', this.onLeftMouseMove);
		document.body.removeEventListener('mousemove', this.onRightMouseMove);
		document.body.removeEventListener('mousemove', this.onMove);
		document.body.removeEventListener('mouseup', this.onMouseUp);

		this.setState({
			isDrag: false,
			movementSide: null,
		});

		updateInitiativeDuration(initiative.id, {
			executionStartDate: executionStartDate,
			duration: duration
		});
	};

	render() {
		const { dayWidth, initiative } = this.props;
		const {
			duration,
			handleMovement,
			isDrag,
			movementSide,
		} = this.state;
		const { isFaded, isSummary, top } = initiative;
		const left = this.getLeftInPixels();
		const weekWidth = dayWidth * DAYS_IN_WEEK;
		const handlePosition = duration * weekWidth - MOVE_HANDLE_WIDTH

		return (
			<Container
				isDrag={isDrag}
				isFaded={isFaded}
				isSummary={isSummary}
				top={top}
				left={left}
				width={duration * weekWidth}
				onMouseDown={(e) => {
					e.stopPropagation();
					this.setState({ isDrag: true })
					document.body.addEventListener('mousemove', this.onMove);
					document.body.addEventListener('mouseup', this.onMouseUp);
				}}
			>
				<Label>{getInitiativeLabelText(duration, duration * weekWidth)}</Label>
				{!isSummary && (
					<HandlesWrapper>
						<LeftHandle
							top={top}
							right={handlePosition}
							width={MOVE_HANDLE_WIDTH - (movementSide === 'left' ? handleMovement : 0)}
							onMouseDown={(e) => {
								e.stopPropagation();
								this.setState({ movementSide: 'left' })
								document.body.addEventListener('mousemove', this.onLeftMouseMove);
								document.body.addEventListener('mouseup', this.onMouseUp);
							}}
						/>
						<RightHandle
							top={top}
							className="right-handle"
							left={handlePosition + (movementSide === 'right' && handleMovement < 0 ? handleMovement : 0)}
							width={MOVE_HANDLE_WIDTH + (movementSide === 'right' ? handleMovement : 0)}
							onMouseDown={(e) => {
								e.stopPropagation();
								this.setState({ movementSide: 'right' })
								document.body.addEventListener('mousemove', this.onRightMouseMove);
								document.body.addEventListener('mouseup', this.onMouseUp);
							}}
						/>
					</HandlesWrapper>
				)}
			</Container>
		)
	}
}

export default InitiativeBar;
